<template>
  <div class="d-inline">
    <b-button variant="success" :disabled="isDisabled" @click="onShowModal()">
      {{ 'order_item_approve_fact_and_invoice' | translate('global') }}
    </b-button>
    <Modal ref="approve"
           @onClose="closeModal"
           @onHidden="hideModal"
           :values="modalValues">
      <template slot="body">
        <div class="modal-body">
          <b-col cols="12">
            <b-alert :show="Object.keys(errorMsg).length > 0" variant="danger">
              <p class="text-center">{{ 'order_item_approve_fact_and_invoice_alert' | translate('global') }}</p>

              <p v-for="(error, formName) in errorMsg" :key="formName">
                <strong>{{ formName | translate('global') }}</strong> - {{ error }}
              </p>

            </b-alert>
          </b-col>

          <b-row>
            <b-col cols="12">
              <span>{{ 'order_approve_invoice' | translate('global') }}</span>
              <b-form-group>
                <label>{{ 'comment' | translate('global') }}</label>
                <b-form-textarea type="text" v-model="comment"
                                 :placeholder="'invoice_modal_comment_placeholder' | translate('global')"/>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </template>
      <template slot="footer">
        <b-button variant="primary" data-dismiss="modal" :disabled="spinners.isSending" @click='onSend()'>
          <b-spinner v-if="spinners.isSending" type="grow" small/>
          {{ 'send' | translate('global') }}
        </b-button>
        <b-button variant="secondary" @click="closeModal()" class="ml-2">
          {{ 'cancel' | translate('global') }}
        </b-button>
      </template>
    </Modal>
  </div>
</template>

<script>
  import Modal from '@/views/sharedComponents/Modal';
  import { mapGetters, mapActions } from 'vuex';
  import VuexTypes from '@/store/types/index';
  import statuses from '@/store/statuses';
  import forEach from "lodash.foreach";
  import Vue from "vue";

  const OrdersTypes = VuexTypes.orders;

  export default {
    props: ['id', 'isDisabled'],
    components: { Modal },
    computed: {
      ...mapGetters('Orders', [
        'orderItemsApproveInvoiceReview',
      ])
    },
    watch: {
      orderItemsApproveInvoiceReview: {
        handler: function () {
          this.errorMsg = {}

          if (this.orderItemsApproveInvoiceReview.status === statuses.LOADED) {
            this.closeModal();
            this.alertSuccess();
          } else if (this.orderItemsApproveInvoiceReview.status === statuses.ERROR) {
            forEach(this.orderItemsApproveInvoiceReview.data.data.errors, (data, key) => {
              const splitKey = key.split('.');
              if (splitKey[2] === 'items') {
                Vue.set(
                  this.errorMsg,
                  splitKey[4],
                  `${data[0]} ( ${this.$t('required_to_all_products', 'global')})`
                );
              } else if (splitKey[0] === 'invoice_item_sum') {
                Vue.set(this.errorMsg, splitKey[0], data[0]);
              } else {
                Vue.set(this.errorMsg, splitKey[2], data[0]);
              }
            });

            this.alertError();
          }
          this.spinners.isSending = false;
        },
        deep: true
      }
    },
    data() {
      return {
        spinners: {
          isSending: false
        },
        comment: '',
        modalValues: {
          id: 'approve-invoice',
          title: this.$t('are_you_sure', 'global'),
        },
        errorMsg: {}
      }
    },
    methods: {
      ...mapActions('Orders', [
        OrdersTypes.ORDER_ITEMS_APPROVE_INVOICE_REVIEW
      ]),
      onShowModal(data) {
        this.$refs['approve'].show();
        this.deleteData = data;
      },
      closeModal() {
        this.$refs['approve'].hide();
        this.errorMsg = {}
      },
      hideModal() {
        this.errorMsg = {}
      },
      onSend() {
        this.spinners.isSending = true;
        this.ORDER_ITEMS_APPROVE_INVOICE_REVIEW({
          orderId: this.$route.params.id,
          invoiceId: this.id,
          sendData: {
            comment: this.comment
          }
        });
      },
    }
  }
</script>

<style scoped>
</style>
